import { Badge, Group, Tabs as MantineTabs, Text } from '@mantine/core'
import { useId } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import classes from './Tabs.module.css'

export interface TabsItem {
  label: string
  path: string
  unviewed?: number
  match?: string
  index?: boolean
}

export interface TabsProps {
  data: TabsItem[]
}

export const Tabs = (props: TabsProps) => {
  const { data } = props
  const id = useId()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const handleTabChange = (value: string | null) => value && navigate(value)

  const activeMatch = (tab: TabsItem) => {
    return tab?.match ? tab.path === pathname : pathname.includes(tab.path)
  }

  return (
    <MantineTabs
      className={classes.Tabs}
      value={pathname}
      onChange={handleTabChange}
    >
      <MantineTabs.List className={classes.Tabs__list}>
        {data.map((tab: TabsItem, index: number) => (
          <MantineTabs.Tab
            className={classes.Tabs__item}
            key={`tabs-${id}-${index}`}
            value={tab.path}
            data-active-match={activeMatch(tab)}
            onClick={() => handleTabChange(tab.path)}
          >
            <Group>
              <Text size="sm">{tab.label}</Text>
              {tab?.unviewed && (
                <Badge color="orange.6" size="sm">
                  {tab.unviewed}
                </Badge>
              )}
            </Group>
          </MantineTabs.Tab>
        ))}
      </MantineTabs.List>
    </MantineTabs>
  )
}
